import { useRef, useState } from 'react';
import { uploadChantierFile } from '../lib/fileService';

function ChantierUploadModal({ chantier, userId, onClose }) {
  const [isDragging, setIsDragging] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [uploadedNames, setUploadedNames] = useState([]);
  const [error, setError] = useState(null);
  const inputRef = useRef(null);

  const uploadFiles = async (fileList) => {
    const files = Array.from(fileList);
    if (files.length === 0) return;

    setError(null);
    setUploading(true);
    try {
      for (const file of files) {
        await uploadChantierFile(file, chantier.id, userId);
        setUploadedNames((prev) => [...prev, file.name]);
      }
    } catch (err) {
      setError(`Échec de l'envoi : ${err.message}`);
    } finally {
      setUploading(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    uploadFiles(e.dataTransfer.files);
  };

  return (
    <div className="ModalOverlay" onClick={onClose}>
      <div className="Modal" onClick={(e) => e.stopPropagation()}>
        <div className="Modal-header">
          <div>
            <h2 className="Modal-title">{chantier.name}</h2>
            <p className="Modal-subtitle">Déposer un fichier</p>
          </div>
          <button className="Modal-close" onClick={onClose} aria-label="Fermer">×</button>
        </div>

        <div className="Modal-body">
          <div
            className={`Dropzone${isDragging ? ' is-dragging' : ''}`}
            onClick={() => inputRef.current?.click()}
            onDragOver={(e) => {
              e.preventDefault();
              setIsDragging(true);
            }}
            onDragLeave={() => setIsDragging(false)}
            onDrop={handleDrop}
          >
            <p className="Dropzone-text">
              {uploading ? 'Envoi en cours…' : 'Glissez vos fichiers ici'}
            </p>
            <p className="Dropzone-hint">ou cliquez pour parcourir</p>
            <input
              ref={inputRef}
              type="file"
              multiple
              hidden
              disabled={uploading}
              onChange={(e) => {
                uploadFiles(e.target.files);
                e.target.value = '';
              }}
            />
          </div>

          {uploadedNames.length > 0 && (
            <ul className="FileList">
              {uploadedNames.map((name, index) => (
                <li className="FileList-item" key={`${name}-${index}`}>
                  <span>✓ {name}</span>
                </li>
              ))}
            </ul>
          )}

          {error && <p className="Modal-error">{error}</p>}
        </div>
      </div>
    </div>
  );
}

export default ChantierUploadModal;
